<template>
  <b-row v-loading="visible" id="loading"></b-row>
</template>
<script>
  import Vue from 'vue';
  import { Loading } from 'element-ui';

  Vue.use(Loading.directive);
  export default {
    name: 'loading-panel',
    props: {
      visible: {
        type: Boolean,
        default: false,
        description: 'Show loading if true'
      }      
    }
  };
</script>
<style>

</style>
